function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.000300322 1.11556C0.00704851 1.40301 0.126313 1.67612 0.332114 1.8754L10.388 12.0024L0.332115 22.1293C0.228456 22.2309 0.146061 22.3523 0.0897952 22.4865C0.0335299 22.6206 0.00453662 22.7648 0.0045282 22.9104C0.00458479 23.1272 0.068838 23.3391 0.189073 23.5189C0.309309 23.6987 0.480062 23.8383 0.679505 23.9199C0.878947 24.0015 1.09802 24.0213 1.3087 23.9768C1.51939 23.9324 1.71212 23.8256 1.86226 23.6703L12.6832 12.7728C12.886 12.5685 13 12.2913 13 12.0024C13 11.7134 12.886 11.4362 12.6832 11.2319L1.86226 0.334438C1.71114 0.176178 1.51609 0.0675735 1.30264 0.02285C1.08919 -0.0218735 0.867304 -0.000629463 0.666049 0.0837993C0.464794 0.16823 0.293553 0.311911 0.174759 0.496014C0.0559647 0.680119 -0.00484314 0.896063 0.000300322 1.11556Z",
  fill: "#201858"
});

var SvgCaret = function SvgCaret(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaret, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret.9cd156e9.svg";
export { ForwardRef as ReactComponent };